import UserCard from "./userCard";

const UsersList = () => {
  return <UserCard />;
};

export default UsersList;
